import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { DEFAULT_ALLOWED_FILE_TYPES, FILE_TYPE_LABELS } from "../../../utils/constant";
const FileUploadBox = ({ onFileSelect, fileUpload, file, errorMessage: externalErrorMessage, allowedTypes = DEFAULT_ALLOWED_FILE_TYPES }) => {
  const theme = useTheme();
  const [internalError, setInternalError] = useState("");

  useEffect(() => {
    if (externalErrorMessage) setInternalError("");
  }, [externalErrorMessage]);

  const allowedLabel = allowedTypes.map(type => FILE_TYPE_LABELS[type] || type).join(", ");

  const validateAndSelect = selectedFile => {
    if (!selectedFile) return;

    if (allowedTypes.length && !allowedTypes.includes(selectedFile.type)) {
      setInternalError(`Invalid file format. Please upload a supported file type (${allowedLabel}).`);
      return;
    }

    setInternalError("");
    onFileSelect(selectedFile);
  };

  const handleDrop = event => {
    event.preventDefault();
    validateAndSelect(event.dataTransfer.files[0]);
  };

  const handleFileChange = event => {
    validateAndSelect(event.target.files[0]);
  };

  const errorMessage = internalError || externalErrorMessage;

  return (
    <Box
      onDrop={handleDrop}
      onDragOver={e => e.preventDefault()}
      onClick={() => document.getElementById("fileInput").click()}
      sx={{
        border: `1px dashed ${theme.palette.compliancenavigator.baseuploadmodal.boxBorder}`,
        padding: "40px",
        textAlign: "center",
        cursor: "pointer",
        backgroundColor: theme.palette.compliancenavigator.baseuploadmodal.boxBackground
      }}
    >
      <input type="file" id="fileInput" style={{ display: "none" }} onChange={handleFileChange} accept={allowedTypes.join(",")} />

      <img src={fileUpload} alt="file" />

      <Typography variant="body1" fontWeight="bold" sx={{ color: theme.palette.compliancenavigator.baseuploadmodal.typographyColor }}>
        {file ? `File Uploaded: ${file.name}` : `Click or Drag & Drop File Here (${allowedLabel})`}
      </Typography>

      <p style={{ color: "red" }}>{errorMessage}</p>
    </Box>
  );
};

export default FileUploadBox;